// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

interface BrandingProps {
  variant?: 'default' | 'inverse';
  compact?: boolean;
  className?: string;
}

const COPYRIGHT = '© 2026 Query Health, Inc.';

export function Branding({ variant = 'default', compact = false, className }: BrandingProps) {
  const inverse = variant === 'inverse';

  return (
    <footer
      aria-label={COPYRIGHT}
      title={compact ? COPYRIGHT : undefined}
      className={[
        'text-center text-xs',
        inverse ? undefined : 'text-muted-foreground',
        className,
      ].filter(Boolean).join(' ')}
      style={inverse ? { color: 'rgba(255, 255, 255, 0.55)' } : undefined}
    >
      {compact ? (
        <span style={{ display: 'block', fontSize: '9px', lineHeight: 1, whiteSpace: 'nowrap' }}>© 2026</span>
      ) : COPYRIGHT}
    </footer>
  );
}
